import { render, staticRenderFns } from "./LogicJump.vue?vue&type=template&id=20d9186e&"
import script from "./LogicJump.vue?vue&type=script&lang=ts&"
export * from "./LogicJump.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports